import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../../services/ApiService";
import DatePicker from "react-datepicker";

export default function CreateAssert({
  closeModal,
  users,
  offices,
  assetscategories,
  alert,
  getAllAssets,
}) {
  const Offices = {
    frontOffice: "front office",
    middleOffice: "middle office",
    backOffice: "back office",
  };

  let frontOfficeUser = users.filter(
    (user) => user.office && user.office.toLowerCase() === Offices.frontOffice
  );
  let middleOfficeUser = users.filter(
    (user) => user.office && user.office.toLowerCase() === Offices.middleOffice
  );
  let backOfficeUsers = users.filter(
    (user) => user.office && user.office.toLowerCase() === Offices.backOffice
  );

  return (
    <React.Fragment>
      <Formik
        initialValues={{
          name: "",
          description: "",
          category_id: "",
          price: "",
          user_id: "",
          office_id: "",
          date_acquired: new Date(),
        }}
        onSubmit={(values) => {
          ApiService.post("assets/add-asset", values).then((res) => {
            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
              getAllAssets();
              closeModal();
            }
          });
        }}
      >
        {({
          handleSubmit,
          values,
          isSubmitting,
          setFieldValue,
          handleChange,
        }) => (
          <Form>
            <div className="form-group">
              <label>
                {" "}
                Name <span className="text-danger"> * </span>{" "}
              </label>
              <Field
                type="text"
                className="form-control"
                id="name"
                name="name"
                placeholder="Assest Name"
                autoComplete="off"
                required
              />
            </div>
            <div className="form-group">
              <label>
                {" "}
                Asset Description <span className="text-danger"> * </span>
              </label>
              <Field
                type="text"
                className="form-control"
                id="description"
                name="description"
                placeholder="Asset Description"
                autoComplete="off"
                required
              />
            </div>

            <div className="form-group">
              <label>
                {" "}
                Asset category<span className="text-danger"> * </span>
              </label>
              <select
                type="text"
                className="form-control"
                id="category_id"
                name="category_id"
                onChange={handleChange}
                required
              >
                <option value="">--Select Category--</option>

                {assetscategories.map((category, i) => (
                  <option value={category.id} key={i}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>
                {" "}
                Date Acquired <span className="text-danger"> * </span>
              </label>
              <DatePicker
                selected={values.date_acquired}
                maxDate={new Date()}
                showDisabledMonthNavigation
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="date_acquired"
                onChange={(date) => setFieldValue("date_acquired", date)}
                autoComplete="off"
                required
              />{" "}
            </div>

            <div className="form-group">
              <label>
                Office <span className="text-danger"> * </span>
              </label>
              <select
                type="text"
                className="form-control"
                name="office_id"
                onChange={handleChange}
                required
              >
                <option value="">---Select options---</option>

                {offices.map((office, i) => (
                  <option value={office.id} key={i}>
                    {office.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>
                Beneficiary<span className="text-danger"> * </span>{" "}
              </label>
              <select
                type="text"
                className="form-control"
                onChange={handleChange}
                name="user_id"
                id="user_id"
                required
              >
                <option value="">--Select Benficiary--</option>
                {values.office_id === "1"
                  ? frontOfficeUser.map((user, i) => (
                      <option value={user.id} key={i}>
                        {user.first_name}
                      </option>
                    ))
                  : values.office_id === "2"
                  ? middleOfficeUser.map((user, i) => (
                      <option value={user.id} key={i}>
                        {user.first_name}
                      </option>
                    ))
                  : values.office_id === "3"
                  ? backOfficeUsers.map((user, i) => (
                      <option value={user.id} key={i}>
                        {user.first_name}
                      </option>
                    ))
                  : null}
              </select>
            </div>
            <div className="form-group">
              <label> Price</label>
              <Field
                type="number"
                className="form-control"
                id="price"
                name="price"
                placeholder="Price"
                autoComplete="off"
              />
            </div>
            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/modal/create_assert.js